import Touchable from '@components/Touchable'
import { Box, Input, InputProps, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'

interface IProps extends InputProps {
  button?: boolean
  error?: boolean
  onFocused?: () => void
  errorMessage?: string
}

export default function RainbowTextField({
  button,
  error,
  onFocused,
  errorMessage,
  ...inputProps
}: IProps) {
  const [focused, setFocused] = useState(false)

  if (button) {
    return (
      <Touchable>
        <Box
          display="flex"
          flexGrow={1}
          sx={{
            background: (theme) =>
              error ? theme.palette.rainbow.red : theme.palette.background.rainbow,
            borderRadius: 1,
            p: '2px',
          }}
        >
          <Input
            disableUnderline
            sx={{
              px: 2,
              py: 1,
              background: (theme) => theme.palette.background.paper,
              borderRadius: 1,
            }}
            fullWidth
            value={inputProps.value}
            endAdornment={inputProps.endAdornment}
            autoComplete="off"
            readOnly
          />
        </Box>
      </Touchable>
    )
  }

  return (
    <Touchable scaleFactor={0.05} disableHover tabIndex={-1}>
      <Stack
        sx={{
          background: (theme) =>
            error
              ? theme.palette.error.main
              : inputProps.disabled || !focused
                ? theme.palette.background.rainbowDisabled
                : theme.palette.background.rainbow,
          borderRadius: 1,
          p: '2px',
        }}
      >
        <Input
          disableUnderline
          sx={{
            px: 2,
            py: 1,
            background: (theme) => theme.palette.background.paper,
            borderRadius: 1,
          }}
          fullWidth
          onFocus={() => {
            setFocused(true)
            onFocused?.()
          }}
          onBlur={() => setFocused(false)}
          autoComplete="off"
          {...inputProps}
        />
      </Stack>
      {errorMessage && <Typography color="red">{errorMessage}</Typography>}
    </Touchable>
  )
}
